/* src/app/shared/dialog/comment-edit-dialog/comment-edit-dialog.component.scss */
.comment-edit-dialog-layout {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.edit-dialog-container {
  background-color: rgba(36, 70, 102, 0.05);
  border-radius: 5px;
  padding: 15px;
}
.edit-dialog-container .title-div {
  padding-bottom: 0;
}
.edit-dialog-container .tv-container-hour-input {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.edit-dialog-container .name-date {
  display: flex;
  flex-flow: row nowrap;
  gap: 10px;
  width: 100%;
  margin-bottom: 10px;
}
.edit-dialog-container .textarea-body {
  height: 300px;
  max-height: 300px;
}
.edit-dialog-container .input-body {
  width: 700px;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}
.button-container .tv-ns-secondary-large-button-on-light-bg,
.button-container .tv-ns-validation-large-button {
  margin: 0;
}
/*# sourceMappingURL=comment-edit-dialog.component.css.map */
